module.exports = __webpack_public_path__ + "static/media/Vec vectores_Location amarillo.e2a976f6.svg";